import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';
import ProductCard from '../product-card/product-card';
import { waitForElm } from '../utils/helpers';

const CollectionGrid = ({ collectionProducts }) => {
  const gridRef = useRef(null);

  useEffect(() => {
    waitForElm('.yotpo.bottomLine').then(() => {
      if (window.yotpo?.initWidgets) {
        window.yotpo.initWidgets();
        let attempts = 0;
        const interval = setInterval(() => {
          if (
            document.querySelectorAll('.yotpo-bottomline a').length > 0 ||
            attempts > 1000
          ) {
            clearInterval(interval);
            window.yotpo.widgets.map((widget) => {
              const widgetNodeStarsText = widget.element.querySelector(
                '.yotpo-bottomline a',
              );
              if (widgetNodeStarsText) {
                widgetNodeStarsText.remove();
              }
              return '';
            });
          }
          attempts += 1;
        }, 100);
      }
    });
  }, []);

  return (
    <div
      className="grid laptop:grid-cols-4 laptop:gap-5 p-5
        pt-0 laptop:px-10 laptop:pt-10 grid-cols-2 gap-2"
      ref={gridRef}
    >
      {collectionProducts.map((data, index) => (
        <ProductCard currentProduct={data.node} key={`product-card-${index}`} />
      ))}
    </div>
  );
};

export default CollectionGrid;
